import { Col, Form, Input, Modal, Row, Button } from 'antd';
import FormItem from 'antd/es/form/FormItem';
import React from 'react';
const { TextArea } = Input;
function ReasonModal({ hideModal, visible, loading, prevInput, opslag }) {
  const [form] = Form.useForm();
  const handleSearch = (reason) => {
    let inputObjs = prevInput;
    inputObjs.forEach((a) => (a.reason = reason));
    opslag(inputObjs);
    hideModal();
  };

  const handleOk = () => {
    form.validateFields().then(({ reason }) => {
      handleSearch(reason);
      form.resetFields();
    });
  };

  return (
    <div>
      <Modal
        title={'Begrundelse'}
        open={visible}
        footer={[
          <Button key='back' onClick={hideModal}>
            Annuller
          </Button>,
          <Button key='submit' type='primary' loading={loading} onClick={handleOk}>
            Søg
          </Button>,
        ]}
        destroyOnClose={true}
        loading={loading}
      >
        <Form form={form} onSubmit={handleSearch}>
          <Row>
            <Col>
              <p>
                Denne person eller virksomhed er blevet søgt på 5 gange i denne kalendermåned. For
                at forsætte søgningen skal du indtaste begrundelsen for denne søgning.
              </p>
            </Col>
          </Row>
          <FormItem
            rules={[
              { required: true, message: 'Indtast venligts en begrundelse for dette opslag' },
            ]}
            required={true}
            name='reason'
          >
            <TextArea rows={4} />
          </FormItem>
        </Form>
      </Modal>
    </div>
  );
}

export default ReasonModal;
